<template>
  <Tooltip.Hint :text="exact" :disabled="compact === exact">
    <span :aria-label="exact" class="relative inline-block truncate">
      <Transition :name="isIncreasing ? 'slide-up' : 'slide-down'">
        <div :key="compact">{{ compact }}</div>
      </Transition>
    </span>
  </Tooltip.Hint>
</template>

<script lang="ts" setup>
import { computed, ref, toRef, watch } from "vue";

import Tooltip from "../Tooltip";

const props = defineProps<{
  value: number | undefined;
}>();

const isIncreasing = ref(true);
watch(toRef(props, "value"), (next = -1, prev = -1) => {
  isIncreasing.value = next > prev;
});

const exact = computed(() => {
  const value = props.value;
  if (value === undefined) {
    return undefined;
  }

  return value.toLocaleString();
});

const compact = computed(() => {
  const value = props.value;
  if (value === undefined) {
    return `—`;
  }

  if (Math.abs(value) < 10_000) {
    return value.toLocaleString();
  }

  return value.toLocaleString(undefined, {
    notation: "compact",
    maximumFractionDigits: 2,
    roundingMode: "trunc",
  });
});
</script>

<style scoped>
.slide-up-enter-active {
  animation: slide-up-enter 300ms ease;
}

.slide-up-leave-active {
  animation: slide-up-leave 300ms ease;
  position: absolute;
}

@keyframes slide-up-enter {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 100%;
  }
}

@keyframes slide-up-leave {
  from {
    transform: translateY(0);
    opacity: 100%;
  }
  to {
    transform: translateY(-100%);
    opacity: 0%;
  }
}

.slide-down-enter-active {
  animation: slide-down-enter 300ms ease;
}

.slide-down-leave-active {
  animation: slide-down-leave 300ms ease;
  position: absolute;
}

@keyframes slide-down-enter {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 100%;
  }
}

@keyframes slide-down-leave {
  from {
    transform: translateY(0);
    opacity: 100%;
  }
  to {
    transform: translateY(100%);
    opacity: 0%;
  }
}
</style>
